

/**
 * Official Ko-fi Cup SVG Icon matching official brand guidelines.
 */
export const KofiIcon = ({ className = "w-5 h-5" }) => (
  <svg 
    viewBox="0 0 24 24" 
    className={className} 
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M23.881 8.948c-.773-4.085-4.859-4.593-4.859-4.593H.723c-.604 0-.679.798-.679.798s-.082 7.324-.022 11.822c.063 4.716 3.72 4.75 3.72 4.75h10.873c4.91 0 5.842-4.68 5.842-4.68s2.509-.043 3.391-2.224c.919-2.27.033-5.873-.016-5.873zm-3.053 4.797c-.558 1.376-2.053 1.376-2.053 1.376H15.93v-4.94h2.845s1.956.12 2.053 3.564z" />
    <path d="M12.723 9.42c-.521-.522-1.365-.522-1.887 0l-.836.837-.837-.837c-.521-.522-1.365-.522-1.886 0-.522.522-.522 1.366 0 1.887l2.723 2.723 2.723-2.723c.522-.521.522-1.365 0-1.887z" />
  </svg>
);

/**
 * Official Ko-fi Button component adhering to Ko-fi official brand colors (#FF5E5B) and assets.
 */
const KofiButton = ({ 
  username = "notkoneko", 
  variant = "full", 
  text, 
  className = "" 
}) => {
  const url = `https://ko-fi.com/${username}`;

  if (variant === "compact") {
    return (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className={`px-3 sm:px-4 py-2 bg-[#FF5E5B]/15 hover:bg-[#FF5E5B]/25 border border-[#FF5E5B]/40 text-white text-xs font-bold rounded-xl transition-all flex items-center gap-2 shrink-0 group ${className}`}
        title="Support on Ko-fi"
      >
        <img 
          src="https://storage.ko-fi.com/cdn/cup-border.png" 
          alt="Ko-fi cup" 
          className="w-4 h-4 object-contain group-hover:scale-110 transition-transform"
          onError={(e) => {
            e.target.style.display = 'none';
          }}
        />
        <span>{text || "Ko-fi"}</span>
      </a>
    );
  }

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center gap-2.5 px-6 py-3 bg-[#FF5E5B] hover:bg-[#ff4a47] text-white font-bold text-sm rounded-xl transition-all shadow-lg shadow-[#FF5E5B]/30 transform hover:scale-105 active:scale-95 ${className}`}
    >
      <img 
        src="https://storage.ko-fi.com/cdn/cup-border.png" 
        alt="Ko-fi cup" 
        className="w-5 h-5 object-contain"
        onError={(e) => {
          e.target.style.display = 'none';
        }}
      />
      <span>{text || "Support on Ko-fi"}</span>
    </a>
  );
};

export default KofiButton;
